export enum YesNoValue {
  No = 0,
  Yes = 1
}
